import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/timeline-2pm";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/wedding-day-timeline_/2pm-ceremony")({
  head: SEO["/wedding-day-timeline/2pm-ceremony"],
  component: () => <ContentPage path="/wedding-day-timeline/2pm-ceremony" body={body} />,
});
